import * as React from "react";
import { forwardRef } from "react";
const SvgCheckOutlined = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-svgr-icon": "true", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M4 7.93995L6.79058 11.0098C6.80558 11.0263 6.82386 11.0394 6.84425 11.0485C6.86464 11.0575 6.88669 11.0621 6.90899 11.0621C6.93129 11.0621 6.95334 11.0575 6.97373 11.0485C6.99412 11.0394 7.0124 11.0263 7.0274 11.0098L12.0005 5.53979", stroke: "#4F4F4F", strokeWidth: 2, strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgCheckOutlined);
export { ForwardRef as ReactComponent };
